module.exports = __webpack_public_path__ + "img/bd.3ce48745.svg";